import { render } from "./FormsMain.vue?vue&type=template&id=6a56035c&scoped=true&lang=true"
import script from "./FormsMain.vue?vue&type=script&lang=js"
export * from "./FormsMain.vue?vue&type=script&lang=js"

import "./FormsMain.vue?vue&type=style&index=0&id=6a56035c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6a56035c"

export default script